/* eslint-disable max-len */
import * as React from 'react';
import { SVGProps, useMemo } from 'react';
import { getIconGradientColors } from './colorUtils';

type PropertyColorableProps = SVGProps<SVGSVGElement> & {
  color?: string;
};

const PropertyColorable = ({ color, ...props }: PropertyColorableProps) => {
  const gradientId = useMemo(
    () => `property_colorable_${Math.random().toString(36).substr(2, 9)}`,
    [],
  );
  const { primary, secondary } = getIconGradientColors('Property', color);

  return (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="24" cy="24" r="24" fill={`url(#${gradientId})`} />
      <g transform="translate(9.25, 7.68)" stroke="#F7F5F8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none">
        <path d="M2.27726 13.0506V27.3233C2.27726 27.8756 2.72498 28.3233 3.27726 28.3233H4.0591C4.61139 28.3233 5.0591 27.8756 5.0591 27.3233V17.2134C5.0591 16.6611 5.50682 16.2134 6.0591 16.2134H12.6353C13.1875 16.2134 13.6353 16.6611 13.6353 17.2134V27.3233C13.6353 27.8756 14.083 28.3233 14.6353 28.3233H26.7318C27.2841 28.3233 27.7318 27.8756 27.7318 27.3233V13.0506" />
        <path d="M8.89542 3.33755V2.85059C8.89542 2.2983 8.44771 1.85059 7.89542 1.85059H6.33179C5.7795 1.85059 5.33179 2.2983 5.33179 2.85059V6.9415" />
        <path d="M0.75 15.087L14.546 1.04906C14.9379 0.650309 15.5806 0.650312 15.9725 1.04907L29.7682 15.087" />
        <path d="M11.4408 22.9779H9.91357" />
        <rect x="16.5319" y="15.5961" width="8.65454" height="7.12727" rx="1" />
      </g>
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="39.177" y2="47.0193" gradientUnits="userSpaceOnUse">
          <stop stopColor={primary} />
          <stop offset="1" stopColor={secondary} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default PropertyColorable;
